import type { DeckDesignerResult } from "../../../http/deckDesigner/formulas";
import { RECTANGULAR_SHAPE } from "../../../http/deckDesigner/types/configurations";
import type { DeckDesignerConfigurationFormValues } from "../../../http/deckDesigner/useAutoSaveDeckDesignerConfiguration";

// Gates the PDF export on the whole configuration being filled in, not just "some row exists" -
// deliberately re-checking the raw selection fields here (rather than relying on RHF's own
// formState.isValid) since none of this form's fields are actually registered with a `required`
// rule, so isValid would stay true even with most of the configuration still empty. secondaryBase/
// secondaryHeight only matter for an L-shaped deck; secondaryItem is optional. The three screw
// fields are required only when ConnectorsCard shows them (same conditions as its
// shouldShowConnectorScrew/shouldShowConnectorBoardScrew/shouldShowSupportScrew), so a missing
// screw blocks the PDF even if its "no compatible screw" form error isn't there.
export const isConfigurationComplete = (
  result: DeckDesignerResult,
  groovingType: DeckDesignerConfigurationFormValues["groovingType"],
  hasFormErrors: boolean,
): boolean => {
  const substructureMaterialCode = result.substructureMaterialClass?.substructureMaterial.code;
  const isConnectorSubstructureScrewRequired =
    !!result.connector && !result.connector.screw && !result.connector.connectorFamily.isScrew;
  const isConnectorBoardScrewRequired =
    isConnectorSubstructureScrewRequired && result.connector?.connectorFamily.requiresBoardScrew === true;
  const isSupportScrewRequired = !!result.support?.supportFamily.screwFamilies.some(
    (screwFamily) =>
      !substructureMaterialCode || screwFamily.substructureMaterials.some((m) => m.code === substructureMaterialCode),
  );

  return (
    !hasFormErrors &&
    result.liveLoad != null &&
    result.deflection != null &&
    result.shape != null &&
    result.base != null &&
    result.height != null &&
    (result.shape === RECTANGULAR_SHAPE || (result.secondaryBase != null && result.secondaryHeight != null)) &&
    result.totalHeight != null &&
    result.hasHorizontalBoards != null &&
    result.fasteningType != null &&
    groovingType != null &&
    result.gap != null &&
    result.connector != null &&
    result.boardWidth != null &&
    result.boardThickness != null &&
    result.substructureMaterialClass != null &&
    result.substructure != null &&
    result.joistsSpacing != null &&
    result.support != null &&
    (!isConnectorSubstructureScrewRequired || result.connectorSubstructureScrew != null) &&
    (!isConnectorBoardScrewRequired || result.connectorBoardScrew != null) &&
    (!isSupportScrewRequired || result.supportScrew != null)
  );
};
